import React from "react";

/** Simple centered loading indicator */
export default function Loader({ label = "Loading…" }) {
  return (
    <div className="loader-wrap" role="status" aria-live="polite">
      <div className="loader-spinner" aria-hidden />
      <p className="loader-label">{label}</p>
    </div>
  );
}
